module.exports = __webpack_public_path__ + "img/chess-hotel.27865ed0.png";